<template>

	<div class="commonfoot" style="background: black;">

		<feedbackpop ref="feedbackpop"></feedbackpop>
		<div class="commonfoot_main">
			<span class="copyright">
			北京帮威客科技有限公司 版权所有 Copyright <span id="copyright"> © </span> 京ICP备17022008号-7
		</span>
		<span class="commonfootright">
			<a style='cursor: auto;'>
			邮箱：bytev@bangweike.com
			</a>
			<router-link to="/yonghuxieyi" style='cursor: pointer;'>
				用户协议
			</router-link>
			<a @click="openfeedbackpop" style='cursor: pointer;'>
				意见反馈
			</a>
		</span>
		</div>
		<div id="rightButton">
	 <div class="side-bar">
		 <div class="side-barDiv">
        	<a href="#" class="icon-qq" style="	display: flex;justify-content: center;align-items: center;margin-right: 41px;">
				<!-- <svg t="1606223401892" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2757" width="200" height="200"><path d="M953.6 569.6c-19.2-51.2-44.8-96-70.4-121.6v-12.8c0-32-6.4-57.6-25.6-83.2C857.6 160 704 0 512 0 320 0 166.4 160 166.4 352c-19.2 25.6-25.6 57.6-25.6 83.2V448c-25.6 25.6-51.2 70.4-70.4 121.6-32 102.4-25.6 217.6 38.4 243.2 25.6 6.4 44.8 0 70.4-12.8-38.4 25.6-57.6 57.6-57.6 89.6 0 76.8 89.6 128 211.2 128 64 0 121.6-19.2 160-44.8h38.4c38.4 25.6 96 44.8 160 44.8 121.6 0 211.2-51.2 211.2-128 0-38.4-19.2-70.4-57.6-89.6 19.2 19.2 44.8 19.2 70.4 12.8 64-25.6 70.4-140.8 38.4-243.2zM896 768c-12.8 6.4-32-12.8-38.4-19.2-6.4-6.4-12.8-12.8-19.2-6.4-6.4 0-12.8 6.4-19.2 12.8-6.4 19.2-19.2 32-32 51.2-6.4 6.4-6.4 12.8-6.4 19.2 0 6.4 6.4 12.8 12.8 19.2 38.4 12.8 57.6 38.4 57.6 57.6 0 44.8-70.4 76.8-160 76.8-57.6 0-108.8-12.8-134.4-38.4-6.4-6.4-12.8-6.4-19.2-6.4h-51.2c-6.4 0-12.8 0-19.2 6.4-25.6 25.6-83.2 38.4-134.4 38.4-89.6 0-160-32-160-76.8 0-25.6 19.2-44.8 57.6-57.6 6.4 0 12.8-6.4 12.8-19.2 0-6.4 0-12.8-6.4-19.2-12.8-12.8-25.6-32-32-51.2-6.4-6.4-12.8-12.8-19.2-12.8-6.4 0-19.2 0-19.2 6.4-6.4 6.4-25.6 19.2-38.4 19.2-25.6-6.4-38.4-89.6-6.4-179.2 12.8-51.2 44.8-89.6 70.4-108.8 0-12.8 6.4-19.2 0-25.6v-19.2c0-19.2 6.4-44.8 19.2-64 0-6.4 6.4-12.8 6.4-12.8v-6.4C217.6 185.6 352 51.2 512 51.2s294.4 134.4 294.4 300.8v6.4c0 6.4 0 12.8 6.4 12.8 12.8 19.2 19.2 44.8 19.2 64v19.2c0 6.4 0 19.2 6.4 19.2 25.6 25.6 51.2 64 70.4 108.8 25.6 89.6 12.8 172.8-12.8 185.6z" fill="#ffffff" p-id="2758"></path></svg>	 -->
					<svg t="1606297670780" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2735" width="30" height="30"><path d="M511.999 1024a512 512 0 1 0-512-512 512 512 0 0 0 512 512z" fill="#23A0F0" p-id="2736"></path><path d="M735.765 604.422c-3.55-49.47-36.192-90.932-55.09-112.47a70.383 70.383 0 0 0-15.577-67.003v-1.718c0-97.235-68.028-167.254-153.35-167.55-85.333 0.342-153.35 70.315-153.35 167.55v1.718a70.383 70.383 0 0 0-15.576 67.003c-18.898 21.413-51.54 62.874-55.09 112.47a75.39 75.39 0 0 0 7.554 40.425c7.555 10.308 28.513-2.06 43.406-34.93a210.33 210.33 0 0 0 35.499 67.914c-36.307 8.477-46.729 44.897-34.475 64.853 8.59 14.086 28.445 25.657 62.419 25.657 60.473 0 87.267-16.611 99.18-28.057a16.259 16.259 0 0 1 20.844 0c11.913 11.57 38.684 28.057 99.18 28.057 34.02 0 53.715-11.57 62.419-25.657 12.253-19.922 1.831-56.342-34.475-64.853a211.627 211.627 0 0 0 35.499-67.914c14.893 32.87 35.85 45.124 43.406 34.93a76.493 76.493 0 0 0 7.577-40.425z" fill="#FFFFFF" p-id="2737"></path></svg>
					QQ在线咨询
				<div class="hovertree-QQ">
					<i></i>
					<div class="QQImga">
						<!-- <div id="cs_online" style="top: 150px; display: block; right: 10px; opacity: 1;">
					<ul class="qq_context">
						<li>
							<span class="span_t">边老师</span>0
							<span class="qq_num"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=120192354&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:800020304:51" alt="点击咨询" title="点击咨询"></a></span>
						</li>
						<li>
							<span class="span_t">潘老师</span>
							<span class="qq_num"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=35301245&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:800020304:51" alt="点击咨询" title="点击咨询"></a></span>
						</li>
						<li>
							<span class="span_t">高老师</span>
							<span class="qq_num"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=1131198909&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:800020304:51" alt="点击咨询" title="点击咨询"></a></span>
						</li>

					</ul></div> -->
						<div class="QQimag1">
							<b>在线咨询</b>
						</div>
						<div class="QQimag2">
<!--边建涛-->
							<div class="QQimag2Child">
								<div><svg t="1606050203625" class="icon66" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13048" width="200" height="200"><path d="M733.256046 438.213872c-0.921047-59.254048-18.523286-106.329802-52.295023-139.896862-43.084549-42.879872-98.654407-50.248251-119.122127-51.476314l0-0.102339-1.023386 0c-3.377174-0.204677-5.526284-0.204677-5.935639-0.204677l-5.423946 0.102339-5.423946-0.102339c-0.511693 0-2.353788 0-5.730961 0.204677l-1.023386 0 0 0.102339c-20.467719 1.228063-76.139916 8.494104-119.224465 51.373976-33.771737 33.669398-51.476314 80.745153-52.295023 139.896862-11.461923 15.043774-23.3332 41.140116-12.689986 65.906056-16.578853 21.491105-49.941235 72.558065-38.888667 124.443734 1.330402 6.652009 8.903458 38.069958 33.669398 41.856486 14.020388 2.149111 26.096342-5.526284 36.023186-16.578853 3.684189 8.289426 8.187088 16.988207 13.406356 24.970618-3.172497 1.944433-6.447332 3.991205-9.824505 6.344993-23.640216 16.374175-34.897462 33.464721-33.157705 50.657605 0.818709 8.084749 4.912253 19.853688 20.160704 30.087547 10.438537 6.959025 25.072956 12.587647 44.721967 17.295223l0.614032 0.102339c0.921047 0.204677 10.540875 2.046772 24.868279 2.046772 19.649011 0 47.996802-3.581851 74.40016-20.058365l2.353788-1.43274 4.809914 0.921047c8.187088 1.637418 16.271837 2.353788 24.458925 2.353788 8.187088 0 16.374175-0.818709 24.76594-2.353788l3.274835-0.614032 2.251449 1.535079c25.379972 16.374175 51.885669 20.263042 71.125325 20.263042 15.35079 0 25.994004-2.456126 27.631421-2.865481 19.649011-4.707575 34.28343-10.336198 44.721967-17.295223 15.248451-10.131521 19.444333-21.90046 20.160704-30.087547 1.637418-17.192884-9.51749-34.28343-33.157705-50.657605-3.274835-2.251449-6.652009-4.40056-9.824505-6.344993 5.219268-7.982411 9.722167-16.78353 13.406356-24.970618 10.029182 11.052568 22.002798 18.727963 36.023186 16.578853 24.76594-3.786528 32.338997-35.204477 33.771737-41.856486 11.052568-51.885669-22.309814-102.952628-38.786328-124.443734C756.589246 479.353988 744.717969 453.359984 733.256046 438.213872zM959.731361 367.088547c-21.798121-51.476314-52.909055-97.631021-92.514092-137.236058-39.605037-39.605037-85.862083-70.818309-137.236058-92.514092C676.662802 114.823906 620.171897 103.361983 561.838897 103.361983s-114.823906 11.461923-168.142315 33.976414c-51.476314 21.798121-97.631021 52.909055-137.236058 92.514092s-70.818309 85.862083-92.514092 137.236058C141.431941 420.406956 129.970018 476.897861 129.970018 535.230861s11.461923 114.823906 33.976414 168.142315c21.798121 51.476314 52.909055 97.631021 92.514092 137.236058 39.605037 39.605037 85.862083 70.818309 137.236058 92.514092 53.21607 22.514491 109.809314 33.976414 168.142315 33.976414s114.823906-11.461923 168.142315-33.976414c51.476314-21.798121 97.631021-52.909055 137.236058-92.514092 39.605037-39.605037 70.818309-85.862083 92.514092-137.236058 22.514491-53.21607 33.976414-109.809314 33.976414-168.142315S982.245852 420.406956 959.731361 367.088547zM561.838897 922.070758c-213.273636 0-386.839896-173.56626-386.839896-386.839896s173.56626-386.839896 386.839896-386.839896 386.839896 173.56626 386.839896 386.839896S775.112532 922.070758 561.838897 922.070758z" p-id="13049" fill="#1296db"></path></svg></div>
								<div class="QQimag2Content" style="padding-top:9px"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=120192354">业务咨询一</a></div>
							</div>
<!--dary-->
							<div class="QQimag2Child">
								<div><svg t="1606050203625" class="icon66" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13048" width="200" height="200"><path d="M733.256046 438.213872c-0.921047-59.254048-18.523286-106.329802-52.295023-139.896862-43.084549-42.879872-98.654407-50.248251-119.122127-51.476314l0-0.102339-1.023386 0c-3.377174-0.204677-5.526284-0.204677-5.935639-0.204677l-5.423946 0.102339-5.423946-0.102339c-0.511693 0-2.353788 0-5.730961 0.204677l-1.023386 0 0 0.102339c-20.467719 1.228063-76.139916 8.494104-119.224465 51.373976-33.771737 33.669398-51.476314 80.745153-52.295023 139.896862-11.461923 15.043774-23.3332 41.140116-12.689986 65.906056-16.578853 21.491105-49.941235 72.558065-38.888667 124.443734 1.330402 6.652009 8.903458 38.069958 33.669398 41.856486 14.020388 2.149111 26.096342-5.526284 36.023186-16.578853 3.684189 8.289426 8.187088 16.988207 13.406356 24.970618-3.172497 1.944433-6.447332 3.991205-9.824505 6.344993-23.640216 16.374175-34.897462 33.464721-33.157705 50.657605 0.818709 8.084749 4.912253 19.853688 20.160704 30.087547 10.438537 6.959025 25.072956 12.587647 44.721967 17.295223l0.614032 0.102339c0.921047 0.204677 10.540875 2.046772 24.868279 2.046772 19.649011 0 47.996802-3.581851 74.40016-20.058365l2.353788-1.43274 4.809914 0.921047c8.187088 1.637418 16.271837 2.353788 24.458925 2.353788 8.187088 0 16.374175-0.818709 24.76594-2.353788l3.274835-0.614032 2.251449 1.535079c25.379972 16.374175 51.885669 20.263042 71.125325 20.263042 15.35079 0 25.994004-2.456126 27.631421-2.865481 19.649011-4.707575 34.28343-10.336198 44.721967-17.295223 15.248451-10.131521 19.444333-21.90046 20.160704-30.087547 1.637418-17.192884-9.51749-34.28343-33.157705-50.657605-3.274835-2.251449-6.652009-4.40056-9.824505-6.344993 5.219268-7.982411 9.722167-16.78353 13.406356-24.970618 10.029182 11.052568 22.002798 18.727963 36.023186 16.578853 24.76594-3.786528 32.338997-35.204477 33.771737-41.856486 11.052568-51.885669-22.309814-102.952628-38.786328-124.443734C756.589246 479.353988 744.717969 453.359984 733.256046 438.213872zM959.731361 367.088547c-21.798121-51.476314-52.909055-97.631021-92.514092-137.236058-39.605037-39.605037-85.862083-70.818309-137.236058-92.514092C676.662802 114.823906 620.171897 103.361983 561.838897 103.361983s-114.823906 11.461923-168.142315 33.976414c-51.476314 21.798121-97.631021 52.909055-137.236058 92.514092s-70.818309 85.862083-92.514092 137.236058C141.431941 420.406956 129.970018 476.897861 129.970018 535.230861s11.461923 114.823906 33.976414 168.142315c21.798121 51.476314 52.909055 97.631021 92.514092 137.236058 39.605037 39.605037 85.862083 70.818309 137.236058 92.514092 53.21607 22.514491 109.809314 33.976414 168.142315 33.976414s114.823906-11.461923 168.142315-33.976414c51.476314-21.798121 97.631021-52.909055 137.236058-92.514092 39.605037-39.605037 70.818309-85.862083 92.514092-137.236058 22.514491-53.21607 33.976414-109.809314 33.976414-168.142315S982.245852 420.406956 959.731361 367.088547zM561.838897 922.070758c-213.273636 0-386.839896-173.56626-386.839896-386.839896s173.56626-386.839896 386.839896-386.839896 386.839896 173.56626 386.839896 386.839896S775.112532 922.070758 561.838897 922.070758z" p-id="13049" fill="#1296db"></path></svg></div>
								<div class="QQimag2Content"  style="padding-top:9px"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=719627991&amp;site=qq&amp;menu=yes">业务咨询二</a></div>
							</div>
<!--aimee-->
							<div class="QQimag2Child">
								<div><svg t="1606050203625" class="icon66" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13048" width="200" height="200"><path d="M733.256046 438.213872c-0.921047-59.254048-18.523286-106.329802-52.295023-139.896862-43.084549-42.879872-98.654407-50.248251-119.122127-51.476314l0-0.102339-1.023386 0c-3.377174-0.204677-5.526284-0.204677-5.935639-0.204677l-5.423946 0.102339-5.423946-0.102339c-0.511693 0-2.353788 0-5.730961 0.204677l-1.023386 0 0 0.102339c-20.467719 1.228063-76.139916 8.494104-119.224465 51.373976-33.771737 33.669398-51.476314 80.745153-52.295023 139.896862-11.461923 15.043774-23.3332 41.140116-12.689986 65.906056-16.578853 21.491105-49.941235 72.558065-38.888667 124.443734 1.330402 6.652009 8.903458 38.069958 33.669398 41.856486 14.020388 2.149111 26.096342-5.526284 36.023186-16.578853 3.684189 8.289426 8.187088 16.988207 13.406356 24.970618-3.172497 1.944433-6.447332 3.991205-9.824505 6.344993-23.640216 16.374175-34.897462 33.464721-33.157705 50.657605 0.818709 8.084749 4.912253 19.853688 20.160704 30.087547 10.438537 6.959025 25.072956 12.587647 44.721967 17.295223l0.614032 0.102339c0.921047 0.204677 10.540875 2.046772 24.868279 2.046772 19.649011 0 47.996802-3.581851 74.40016-20.058365l2.353788-1.43274 4.809914 0.921047c8.187088 1.637418 16.271837 2.353788 24.458925 2.353788 8.187088 0 16.374175-0.818709 24.76594-2.353788l3.274835-0.614032 2.251449 1.535079c25.379972 16.374175 51.885669 20.263042 71.125325 20.263042 15.35079 0 25.994004-2.456126 27.631421-2.865481 19.649011-4.707575 34.28343-10.336198 44.721967-17.295223 15.248451-10.131521 19.444333-21.90046 20.160704-30.087547 1.637418-17.192884-9.51749-34.28343-33.157705-50.657605-3.274835-2.251449-6.652009-4.40056-9.824505-6.344993 5.219268-7.982411 9.722167-16.78353 13.406356-24.970618 10.029182 11.052568 22.002798 18.727963 36.023186 16.578853 24.76594-3.786528 32.338997-35.204477 33.771737-41.856486 11.052568-51.885669-22.309814-102.952628-38.786328-124.443734C756.589246 479.353988 744.717969 453.359984 733.256046 438.213872zM959.731361 367.088547c-21.798121-51.476314-52.909055-97.631021-92.514092-137.236058-39.605037-39.605037-85.862083-70.818309-137.236058-92.514092C676.662802 114.823906 620.171897 103.361983 561.838897 103.361983s-114.823906 11.461923-168.142315 33.976414c-51.476314 21.798121-97.631021 52.909055-137.236058 92.514092s-70.818309 85.862083-92.514092 137.236058C141.431941 420.406956 129.970018 476.897861 129.970018 535.230861s11.461923 114.823906 33.976414 168.142315c21.798121 51.476314 52.909055 97.631021 92.514092 137.236058 39.605037 39.605037 85.862083 70.818309 137.236058 92.514092 53.21607 22.514491 109.809314 33.976414 168.142315 33.976414s114.823906-11.461923 168.142315-33.976414c51.476314-21.798121 97.631021-52.909055 137.236058-92.514092 39.605037-39.605037 70.818309-85.862083 92.514092-137.236058 22.514491-53.21607 33.976414-109.809314 33.976414-168.142315S982.245852 420.406956 959.731361 367.088547zM561.838897 922.070758c-213.273636 0-386.839896-173.56626-386.839896-386.839896s173.56626-386.839896 386.839896-386.839896 386.839896 173.56626 386.839896 386.839896S775.112532 922.070758 561.838897 922.070758z" p-id="13049" fill="#1296db"></path></svg></div>
								<div class="QQimag2Content"  style="padding-top:9px"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=1131198909&amp;site=qq&amp;menu=yes">业务咨询三</a></div>
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
		<div class="side-barDivWechat">
			<a href="#" class="icon-chat" title="微信公众号" style="display: flex;justify-content: center;align-items: center;margin-right: 41px;">
				<!-- <svg t="1606223655875" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3680" width="200" height="200"><path d="M816.551274 248.167103C697.80273 131.500986 553.294498 97.66946 394.437467 140.52757 114.716718 215.994356 28.163433 506.98887 169.479973 696.646394c6.853082 9.198499 8.147564 26.164916 5.545296 38.09769-7.601118 34.868135-18.714224 68.958558-28.000728 103.474676-4.965082 18.455327-7.90504 37.21253 8.632611 52.019771 17.777899 15.921621 36.82572 12.654204 56.258305 2.777253 31.879058-16.200984 64.335261-31.314193 95.763041-48.336892 20.469194-11.086499 38.847773-11.658528 61.942771-5.240351 46.063105 12.799514 93.717452 19.872606 117.992321 24.74866 144.317896-2.603291 249.610988-41.736567 333.958024-129.489166C955.8826 594.966597 954.903296 384.090818 816.551274 248.167103zM763.498988 681.878039C658.864906 785.728268 531.49603 810.562886 393.782551 764.371868c-45.408189-15.229866-82.686211-19.207457-122.088616 7.493671-3.576455 2.423189-8.448416 2.934842-26.51284 8.852622 36.271088-62.917982 9.41851-102.273315-21.181415-146.894581-67.886133-98.989525-54.03773-226.624461 26.78197-318.740438 132.026966-150.480246 390.603139-150.382009 522.634198 0.196475C869.144096 424.455131 867.098507 579.054185 763.498988 681.878039zM640.32976 377.432165c-26.245757-0.961908-47.457872 18.594497-48.955992 45.13906-1.532913 27.1565 16.636912 48.230468 43.304272 50.227961 26.571169 1.989307 48.850591-16.263405 51.568493-42.247196C689.112814 403.14478 667.75846 378.439098 640.32976 377.432165zM385.221572 377.38714c-27.757181 0.205685-48.88743 23.684422-46.821375 52.023864 1.940189 26.610054 23.154349 44.910862 50.212612 43.317575 26.505677-1.560542 46.149063-22.886243 45.152363-49.02046C432.798147 398.345474 410.636405 377.198851 385.221572 377.38714z" p-id="3681" fill="#ffffff"></path></svg> -->
				<svg t="1606297768501" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3639" width="30" height="30"><path d="M512 1.896C229.452 1.896 0 229.452 0 512s229.452 510.104 512 510.104S1022.104 794.548 1022.104 512 794.548 1.896 512 1.896z m-91.022 629.57c-26.548 0-49.304-5.688-75.852-11.377l-75.852 37.926 22.756-66.37c-54.993-37.926-87.23-87.23-87.23-147.912 0-104.296 98.607-185.837 218.074-185.837 108.089 0 201.007 64.474 219.97 153.6-7.585 0-13.274-1.896-20.859-1.896-104.296 0-185.837 77.748-185.837 172.563 0 15.17 1.896 30.34 7.585 45.511-7.585 3.793-15.17 3.793-22.755 3.793z m322.37 77.749l17.067 54.992-58.785-34.133c-22.756 5.689-43.615 11.378-66.37 11.378-104.297 0-185.838-70.163-185.838-157.393S530.963 424.77 635.26 424.77c98.608 0 185.837 70.163 185.837 159.29 0 47.407-32.237 91.021-77.748 125.155z" fill="#46BB36" p-id="3640"></path><path d="M318.578 379.26c0 17.066 13.274 30.34 30.34 30.34s30.341-13.274 30.341-30.34-13.274-30.341-30.34-30.341-30.341 13.274-30.341 30.34z m235.14 159.288c0 13.274 11.378 24.652 24.652 24.652 13.274 0 24.652-11.378 24.652-24.652 0-13.274-11.378-24.652-24.652-24.652-13.274-1.896-24.651 9.482-24.651 24.652z m-81.54-159.289c0 17.067 13.274 30.341 30.34 30.341 17.067 0 30.341-13.274 30.341-30.34 0-17.067-13.274-30.341-30.34-30.341-17.067 0-30.341 13.274-30.341 30.34zM675.08 538.55c0 13.273 11.378 24.651 24.652 24.651 13.274 0 24.652-11.378 24.652-24.652 0-13.274-11.378-24.652-24.652-24.652-13.274-1.896-24.652 9.482-24.652 24.652z" fill="#46BB36" p-id="3641"></path></svg>
				微信
				<div class="hovertree-chat-tips"><i></i>
					<div class="wechatImg">
						<div style="font-size:15px;border-right: 1px solid #ededed;">
							<img style="width:80px;height:80px;margin-bottom:10px" src="../../static/img/terry.png"  />
							<div>杜老师</div>
						</div>
						<div style="font-size:15px;border-right: 1px solid #ededed;">
							<img style="width:80px;height:80px;margin-bottom:10px" src="../../static/img/dary.png"  />
							<div>黄老师</div>
						</div>
						<div style="font-size:15px">
							<img style="width:80px;height:80px;margin-bottom:10px" src="../../static/img/bill.png"  />
							<div>熊老师</div>
						</div>

					</div>
				</div>
			</a>
		</div>
    </div>
</div>
	</div>

</template>

<script>
	import feedbackpop from '@/messageBox/feedbackpop'
	export default{
		data() {
			return{

			}
		},
		methods:{
			// 打开意见反馈弹窗
			openfeedbackpop() {

				this.$refs.feedbackpop.openfeedbackpop()
			}
		},
		components:{
			feedbackpop
		}
	}
</script>

<style>
	.commonfoot{
		/* border-top: 1px solid #999; */
		overflow: hidden;
		width: 100%;
		min-width: 1200px;
		height: 44px;
		line-height: 44px;
		text-align: center;
		color: #9FACBC;
		font-size: 14px;
		position: relative;
		bottom: 0;
	}
	.commonfoot_main{
		margin: 0 auto;
		height: 44px;
		width: 1200px;
	}
	.copyright{
		display: inline-block;
		float: left;
		margin-left: none i !important;
	}
	.commonfootright{
		display: inline-block;
		float: right;
	}
	.commonfoot .commonfootright a{
		margin: 0 15px;
		/*cursor: pointer;*/
		color: #9FACBC;
		text-decoration: none;
	}
.side-bar {
	/* width: 66px; */
	position: fixed;
	bottom: 420px;
	left: 0px;
	font-size: 0;
	line-height: 0;
	z-index: 100;
	padding-right: 30px;
}
.icon-qq,.icon-chat {
	width: 59px;
	height: 59px;
	display: inline-block;
	background-color: #fff;
	margin-bottom: 2px;
	/* border: 1px solid black; */

	box-shadow: 0px 0px 10px 0px
		rgba(0, 0, 0, 0.1);
	border-radius: 4px;
		border: solid 1px transparent;
}


/* .side-bar .icon-qq {
	background-position: 0 -62px;
} */
.side-bar .icon-chat {
	background-position: 0 -130px;
	position: relative;
}


.side-bar .icon-blog {
	background-position: 0 -198px;
}
.side-bar .icon-mail {
	background-position: 0 -266px;
}
.side-bar .icon-totop {
	background-position: 0 -334px;
}
.hovertree-chat-tips {
	padding: 20px;
	border: 1px solid #d1d2d6;
	position: absolute;
	left: 70px;
	top: -55px;
	background-color: #ffffff;
	display: none;
	width: 300px;
}
.hovertree-chat-tips i,.hovertree-QQ i{
	width: 9px;
	height: 16px;
	display: inline-block;
	position: absolute;
	right: -9px;
	top: 80px;
	background-position:-88px -350px;
}
.hovertree-QQ{
	padding-left: 10px;
	border: 1px solid #d1d2d6;
	position: fixed;
	left: 70px;
	/* margin-right: 240px; */
	bottom:380px;
	background-color: #ffffff;
	border-radius: 15px;
	display: none;
}
.QQimag1{
	border-bottom: 1px solid #E5E5E5;
    height: 22px;
    line-height: 22px;
    padding-bottom: 6px;
    text-align: left;
	font-family: FZLTHK--GBK1-0;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.hovertree-chat-tips img {
	width: 138px;
	height: 138px;
}
.QQImga{
	width: 140px;
	height: 200px;
	display: grid;
	grid-template-rows: 50px 150px;
	font-size: 20px;
	padding-top:10px;
	padding-right: 10px;
}
.QQimag2{
	display: grid;
	grid-template-rows: 50px 50px 50px;
}
.QQimag2Child{
	display: grid;
	grid-template-columns:40px 78px;
}
.QQimag2Content>a{
	font-family: FZLTHK--GBK1-0;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.QQimag2Content>a:hover{
	color: #2A80EE;
}
.icon66{
	width: 22px;
	height: 22px;
}
.wechatImg{
	display: grid;
	grid-template-columns: 100px 100px 100px;
}
.side-barDiv,.side-barDivWechat{
	width: 100px;
}
.icon-qq:hover {
	/* background-color: #669fdd; */
		background-color: #ffffff;
	box-shadow: 0px 0px 10px 0px
		rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	border: solid 1px #076bf2;
}
.side-barDiv:hover .hovertree-QQ{
	display: block;

}

.side-bar .side-barDivWechat:hover .hovertree-chat-tips {
	display: block;
}
.icon-chat:hover {
	/* background-color: #669fdd; */
	background-color: #ffffff;
	box-shadow: 0px 0px 10px 0px
		rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	border: solid 1px #076bf2;
}
</style>



// WEBPACK FOOTER //
// src/components/commonfoot.vue